export default "__VITE_ASSET__Bym$CKiz__"